import { createFileRoute, redirect } from '@tanstack/react-router';

import { consumeDeepLink } from '@/lib/deep-link';

export const Route = createFileRoute('/')({
  beforeLoad: () => {
    // After Keycloak's `login-required` round-trip the app lands here on the
    // bare origin (the only registered redirect URI). Restore the deep link the
    // user reloaded on — e.g. the open progress-note builder — instead of
    // dropping them on the demo home. Relative href + reloadDocument:false keeps
    // it a client-side navigation, so it never re-triggers the auth round-trip.
    const deepLink = consumeDeepLink();
    if (deepLink) {
      throw redirect({ href: deepLink, reloadDocument: false });
    }

    // The Patients page is the app's home for the demo.
    throw redirect({ to: '/patients' });
  },
});
